import { FormComponentEnums, FormFieldEnums } from "shared/types/enums";
import { ButtonFieldType } from "shared/types";

type ButtonInputProps = Omit<ButtonFieldType, "type"> & {
  type: FormComponentEnums.Submit | FormFieldEnums.Button;
  onClick?: () => void;
};

const ButtonInput = ({
  className,
  onClick,
  label,
  type,
  id,
}: ButtonInputProps) => {
  const classes = `control-button ${className}`;
  return (
    <>
      <button
        name={id}
        id={id}
        type={type}
        className={classes}
        onClick={onClick}
      >
        {label}
      </button>
    </>
  );
};

export default ButtonInput;
